import "./Print.css";
import * as CSV from "xlsx";

class XlsExport {
  private readonly _audience;
  private readonly _channels;
  private readonly _user;
  private readonly _others;
  private readonly _imgs;
  private readonly _divMinute;
  private _mediaComparativas: any[][] = [];

  constructor(audience, channels, user, others, imgs, divMinute?) {
    this._audience = audience;
    this._channels = channels;
    this._user = user;
    this._others = others;
    this._imgs = imgs;
    this._divMinute = divMinute;
  }

  public setMediaComparativas(mediaComparativas: any[][]) {
    this._mediaComparativas = mediaComparativas;
  }

  public exportCSV(filename: string) {
    let tpBase = parseInt(this._others[1]);
    
    let validRow = this._audience.find(row => Array.isArray(row) && row.length > 4);
    let maxlength = validRow ? validRow.length - 2 - tpBase : this._channels?.length + 2 || 10;
    
    let report = new Array();
    let reportRow = new Array(maxlength).fill(""); 
    let col = 0;

    let rowsFirst = this.processLineRowExportCSV(
      reportRow,
      maxlength,
      this._user
    );

    rowsFirst.forEach((item) => {
      report.push(item);
    });

    if (this._mediaComparativas.length > 0) {
      
      this._mediaComparativas.forEach((mediaRow) => {
        if (Array.isArray(mediaRow) && mediaRow.length > 4) {

          const dataRating = mediaRow[1] || "";
          const minutos = mediaRow[2] || "";
          const indice = mediaRow[3] || "";
          const baseAverage = mediaRow[4] || "";
          const valores = mediaRow[5] || [];
          
          // Primeira linha: Data e período
          let periodoRow = new Array(maxlength).fill("");
          periodoRow[0] = `${dataRating} ${minutos}`.trim();
          report.push(periodoRow);
          
          // Segunda linha: RAT/INDICE + valores dos canais
          let valoresRow = new Array(maxlength).fill("");
          valoresRow[0] = indice || "RAT";
          
          let baseValue = baseAverage || "-";
          if (typeof baseValue === 'string' && baseValue.includes('|')) {
            baseValue = baseValue.split('|')[0];
          }
          // Remove símbolos e formatação, deixando apenas números
          if (typeof baseValue === 'string') {
            baseValue = baseValue.replace('%', '').replace(',', '').replace('.', '');
          }
          valoresRow[1] = baseValue;
          
          for (let i = 0; i < valores.length; i++) {
            const valor = valores[i];
            if (typeof valor === 'string' && valor.includes('|')) {
              valoresRow[i + 2] = valor.split('|')[0] || "-";
            } else {
              valoresRow[i + 2] = valor || "-";
            }
          }
          
          report.push(valoresRow);
        }
      });
      
    }

  // reinicializa o reportRow para prevenir mutações em arrays já adicionados ao report
  reportRow = new Array(maxlength).fill("");

  col = 0;
    reportRow[col] = "MIN";
    col++;
    if (tpBase === 0) {
      reportRow[col] = "BASE";
      col++;
    }

    let resultLabel = this.processLineRowExportCSVLabel(col, reportRow);

    col = resultLabel.col;
    reportRow = resultLabel.reportRow;

    report.push(reportRow);
    reportRow = new Array(maxlength).fill("");

    //linha da audiencia
    this._audience.forEach((linha) => {
      // Se a linha é um título de seção ou linha vazia, adiciona diretamente
      if (!Array.isArray(linha) || linha.length <= 1) {
        report.push(Array.isArray(linha) ? linha : [linha]);
        return;
      }
      
      // Se a linha não tem dados suficientes para ser uma linha de audiência válida, pula
      if (!linha[1] && linha.length < 4) {
        report.push(linha);
        return;
      }
      
      col = 0;
      reportRow[col] = linha[1] || "";
      col++;

      let resultLineTypeZero = this.processLine1RowTypeZero(
        tpBase,
        reportRow,
        linha,
        col
      );
      reportRow = resultLineTypeZero.reportRow;
      col = resultLineTypeZero.col;

      let resultLine1 = this.processLine1RowExportCSV(linha, reportRow, col);
      reportRow = resultLine1.reportRow;
      col = resultLine1.col;

      report.push(reportRow);

      reportRow = new Array(maxlength).fill("");
      col = 0;

      if (tpBase === 1 || this._others[2] === 2) {

        let resultLineTypeOne = this.processLine1RowTypeOne(tpBase, reportRow, linha, col); 
        reportRow = resultLineTypeOne.reportRow;
        col = resultLineTypeOne.col; 

        let resultLine2 = this.processLine2RowExportCSV(linha, reportRow, col);
        reportRow = resultLine2.reportRow;
        col = resultLine2.col;

        report.push(reportRow);
        reportRow = new Array(maxlength).fill("");
      }
    });

    const csv_workbook = CSV.utils.book_new();
    const csv_worksheet = CSV.utils.aoa_to_sheet([]);
    CSV.utils.sheet_add_aoa(csv_worksheet, report, { origin: "A1" });

    CSV.utils.book_append_sheet(csv_workbook, csv_worksheet, "Planilha");
    const csvData = CSV.utils.sheet_to_csv(csv_worksheet, {
      FS: ";",
      strip: true,
    });

    // Cria um blob a partir dos dados CSV
    const blob = new Blob(["\uFEFF" + csvData], {
      type: "text/csv;charset=utf-8;",
    });

    // Faz o download do arquivo CSV
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = filename + ".csv";
    downloadLink.click();
  }

  public processLineRowExportCSV(reportRow, maxlength, userData) {
    let newlinha = true;
    let reportResult = new Array();

    userData.forEach((e) => {
      if (newlinha) {
        reportRow[0] = e;
        newlinha = false;
      } else {
        reportRow[1] = e;
        reportResult.push(reportRow);
        reportRow = new Array(maxlength).fill("");
        newlinha = true;
      }
    });
    return reportResult;
  }
  public processLineRowExportCSVLabel(col: number, reportRow) {
    this._channels.forEach((e) => {
      reportRow[col] = e.label;
      col++;
    });
    return { col, reportRow };
  }

  public processLine1RowExportCSV(linha, reportRow, col) {
    // elementos linha 1
    for (let i = 4; i < linha.length; i++) {
      const cellValue = linha[i];
      if (typeof cellValue === 'string' && cellValue.includes('|')) {
        reportRow[col] = cellValue.split("|")[0];
      } else {
        reportRow[col] = cellValue || "";
      }
      col++;
    }
    return { col, reportRow };
  }

  public processLine2RowExportCSV(linha, reportRow, col) {
      for (let i = 4; i < linha.length; i++) {
      if (this._others[2] === 2) {
        const cellValue = linha[i];
        if (typeof cellValue === 'string' && cellValue.includes('|')) {
          reportRow[col] = cellValue.split("|")[1];
        } else {
          reportRow[col] = "";
        }
        col++;
      }
    }
    return { col, reportRow };
  }
  public processLine1RowTypeZero(tpBase, reportRow, linha, col) {
    if (tpBase === 0) {
      reportRow[col] = linha[2];
      col++;
    }
    return { col, reportRow };
  }

  public processLine1RowTypeOne(tpBase, reportRow, linha, col) {
    if (tpBase === 1) {
      reportRow[col] = linha[2];
      col++;
    } else {
      col += 2;
    }
    return { col, reportRow };
  }
}
export default XlsExport;
